import { withJsonFormsControlProps } from '@jsonforms/react';
import type { ControlProps } from '@jsonforms/core';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { useState } from 'react';

const formatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

function CurrencyControlComponent({
  data,
  handleChange,
  path,
  label,
  enabled,
  visible,
  required,
  errors,
}: ControlProps) {
  const [focused, setFocused] = useState(false);

  if (!visible) return null;

  const displayValue =
    data == null || data === ''
      ? ''
      : focused
        ? String(data)
        : formatter.format(data);

  return (
    <TextField
      label={label}
      value={displayValue}
      required={required}
      disabled={!enabled}
      error={!!errors}
      helperText={errors}
      fullWidth
      size="small"
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">$</InputAdornment>
          ),
        },
      }}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      onChange={(e) => {
        const raw = e.target.value.replace(/[^0-9.]/g, '');
        const num = raw === '' ? undefined : parseFloat(raw);
        handleChange(path, num);
      }}
    />
  );
}

export const CurrencyControl = withJsonFormsControlProps(
  CurrencyControlComponent,
);
